export var hasPaddingProps = function (props) {
    var isUndefined = function (value) { return value === undefined; };
    return (!isUndefined(props.padding) ||
        !isUndefined(props.paddingX) ||
        !isUndefined(props.paddingY) ||
        !isUndefined(props.paddingTop) ||
        !isUndefined(props.paddingBottom) ||
        !isUndefined(props.paddingLeft) ||
        !isUndefined(props.paddingRight));
};
export var PaddingProps = function (props) {
    var paddingObject = {};
    if (props && props.padding !== undefined)
        paddingObject.padding = props.padding;
    if (props && props.paddingX !== undefined)
        paddingObject.paddingX = props.paddingX;
    if (props && props.paddingY !== undefined)
        paddingObject.paddingY = props.paddingY;
    if (props && props.paddingTop !== undefined)
        paddingObject.paddingTop = props.paddingTop;
    if (props && props.paddingBottom !== undefined)
        paddingObject.paddingBottom = props.paddingBottom;
    if (props && props.paddingLeft !== undefined)
        paddingObject.paddingLeft = props.paddingLeft;
    if (props && props.paddingRight !== undefined)
        paddingObject.paddingRight = props.paddingRight;
    return paddingObject;
};
